import styled from 'styled-components';

export const StyledPhoneContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 10px;
  padding: 12px 14px;
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledAddressContainer = styled.div`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  padding: 14px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const StyledPhoneNumber = styled.a`
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  letter-spacing: 1.6px;
  color: ${({ theme }): string => theme.colors.primaryBlue};
  cursor: pointer;
`;
